import { isRwaPairSymbol, type RwaVenueIndex } from "./rwa-venue";

/** Asset classes an arena market is grouped under, in display order. */
export const ARENA_MARKET_ASSET_CLASSES = ["Crypto", "Stocks", "Commodities", "Indices", "FX"] as const;

export type ArenaMarketAssetClass = (typeof ARENA_MARKET_ASSET_CLASSES)[number];

// The SDK reports every HIP-3 market as crypto, so the RWA split is kept here; unmatched RWA → Stocks.
const COMMODITIES = new Set(["GOLD", "SILVER", "COPPER", "PLATINUM", "PALLADIUM", "CL", "BRENTOIL", "NATGAS"]);
const INDICES = new Set([
  "SP500",
  "USA500",
  "XYZ100",
  "JP225",
  "KR200",
  "EWJ",
  "EWY",
  "EWT",
  "EWZ",
  "XLE",
  "SMH",
  "URNM",
]);
const FX = new Set(["EUR", "GBP", "JPY"]);
// hyna dex tokens that are crypto, not RWA.
const RWA_CRYPTO = new Set(["1000PEPE", "BASED", "LIGHTER"]);

/** Asset class of an RWA (HIP-3) base, e.g. "GOLD" → Commodities. */
export function classifyRwaBase(base: string): ArenaMarketAssetClass {
  if (RWA_CRYPTO.has(base)) return "Crypto";
  if (COMMODITIES.has(base)) return "Commodities";
  if (INDICES.has(base)) return "Indices";
  if (FX.has(base)) return "FX";
  return "Stocks";
}

/** Asset class of a clean pair symbol ("GOLD/USDC:USDC"): native Hyperliquid perps are Crypto. */
export function classifyArenaMarket(cleanPairSymbol: string, index: RwaVenueIndex): ArenaMarketAssetClass {
  return isRwaPairSymbol(cleanPairSymbol, index)
    ? classifyRwaBase((cleanPairSymbol.split("/")[0] ?? "").toUpperCase())
    : "Crypto";
}
